import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CaseData } from 'src/app/models/case-data.model';
import { claimSumRemainingAmount } from 'src/types/claim-sum';

import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PaymentPlanStartDialogComponent } from 'src/app/dialogs/payment-plan-start-dialog/payment-plan-start-dialog.component';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { FullPaymentComponent } from './full-payment/full-payment.component';
import { BankTransferComponent } from '../bank-transfer/bank-transfer.component';
import { CustomCheckboxComponent } from '../../custom-checkbox/custom-checkbox.component';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.scss'],
  imports: [
    FullPaymentComponent,
    BankTransferComponent,
    FormsModule,
    ReactiveFormsModule,
    CustomCheckboxComponent,
    MatButton,
    MatProgressSpinner,
    TranslateModule,
  ],
})
export class DepositComponent {
  private fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private dialog = inject(MatDialog);
  private paymentService = inject(PaymentService);

  @Input({ required: true }) caseData!: CaseData;

  readonly paymentForm = this.fb.group({
    aszf: this.fb.control(false, {
      validators: Validators.requiredTrue,
      nonNullable: true,
    }),
    pp: this.fb.control(false, {
      validators: Validators.requiredTrue,
      nonNullable: true,
    }),
  });

  selectedPayment = -1;
  claimsListOpen = false;
  @Output() toggleClaimsList = new EventEmitter();
  paymentLoading = false;
  docID = this.route.snapshot.params['docID'] as string;

  get firstPPIndex() {
    return this.caseData.payment_plans
      .map((pp) => pp.status)
      .indexOf('pending');
  }

  get paymentAmount() {
    if (!this.caseData.is_payment_plan) {
      const sums = Object.values(this.caseData.claim_sums);
      if (sums.length !== 1) {
        return 0;
      }
      return claimSumRemainingAmount(sums[0]);
    }

    if (
      this.selectedPayment < this.firstPPIndex ||
      this.selectedPayment >= this.caseData.payment_plans.length
    ) {
      return 0;
    }

    let sum = 0;
    this.caseData.payment_plans
      .slice(this.firstPPIndex, this.selectedPayment + 1)
      .forEach((pp) => (sum += pp.paymentAmountCurrent));
    return sum;
  }

  get aszf() {
    return this.paymentForm.controls.aszf;
  }
  get pp() {
    return this.paymentForm.controls.pp;
  }

  get installment_payment_translate() {
    return {
      amount: this.paymentAmount,
      // @todo
      // currency: this.caseData.currency,
      currency: 'CURRENCY',
    };
  }

  ppSelected(index: number) {
    this.selectedPayment = index;
  }

  async startPayment() {
    this.paymentLoading = true;

    try {
      await this.paymentService.startPayment({
        caseUuid: this.docID,
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.paymentLoading = false;
    }
  }

  startPaymentPlan() {
    this.dialog.open(PaymentPlanStartDialogComponent, {
      autoFocus: false,
      position: {
        top: '50px',
      },
      data: {
        caseData: this.caseData,
        keyId: this.docID,
      },
    });
  }
}
